var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Details")]),_c('MYOrg',{attrs:{"user":_vm.user,"showInModal":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }